import { createApi } from '@reduxjs/toolkit/query/react'

import { customBaseQueryRtk } from '../../utils/axios'
import { TAG_TYPES } from './constants'

export const rootApi = createApi({
  baseQuery: customBaseQueryRtk,
  tagTypes: TAG_TYPES,
  endpoints: () => ({}),
})
